import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  isSupplierHubTab,
  type SupplierHubTab,
} from '@/features/suppliers/components/supplier-detail'
import { SupplierDetailView } from '@/features/suppliers/suppliers'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId/')({
  validateSearch: (search: Record<string, unknown>): { tab?: SupplierHubTab } =>
    isSupplierHubTab(search.tab) ? { tab: search.tab } : {},
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'supplier.view')) {
      throw redirect({ to: '/suppliers' })
    }
  },
  component: SupplierDetailView,
})
